import { createContext, useContext } from 'react'
import type { Socket } from 'socket.io-client'
import type { ClientToServerEvents, ServerToClientEvents } from './types'

export type AppSocket = Socket<ServerToClientEvents, ClientToServerEvents>

export interface SocketContextValue {
  socket: AppSocket | null
  isConnected: boolean
  connectionError: string | null
  emit: <K extends keyof ClientToServerEvents>(
    event: K,
    payload: Parameters<ClientToServerEvents[K]>[0]
  ) => void
}

export const SocketContext = createContext<SocketContextValue | null>(null)

export function useSocketContext(): SocketContextValue {
  const context = useContext(SocketContext)
  if (!context) {
    throw new Error('useSocketContext must be used within a SocketProvider')
  }
  return context
}
